import { MarketingEntryPoint } from "@redotech/redo-model/advanced-flow/schemas/marketing/marketing";
import { BrandKit } from "@redotech/redo-model/brand-kit";
import { SignupForm } from "@redotech/redo-model/signup-form-schema";
import { RedoMarketingPopupFormInstance } from "@redotech/redo-web/marketing/signup-form/popup-form-instance";
import { memo, useContext, useMemo } from "react";
import { RedoShopifyRpcClientContext } from "../../../client/redo-shopify-rpc-client";

export const SignupFormInstanceWrapper = memo(
  function SignupFormInstanceWrapper({
    brandKit,
    utmParams,
    forceId,
    forceForm,
  }: {
    brandKit: BrandKit;
    utmParams: string;
    forceId?: string;
    forceForm?: SignupForm;
  }) {
    const client = useContext(RedoShopifyRpcClientContext);
    const shopifyCustomerId = useMemo(
      () =>
        (
          globalThis as any
        ).ShopifyAnalytics?.meta?.page?.customerId?.toString() ?? null,
      [],
    );
    return (
      <RedoMarketingPopupFormInstance
        brandKit={brandKit}
        entryPoint={MarketingEntryPoint.SIGNUP_FORM}
        forceForm={forceForm}
        forceId={forceId}
        rpcClient={client}
        shopifyCustomerId={shopifyCustomerId}
        site="marketing"
        utmParams={utmParams}
      />
    );
  },
);
